'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useCallback, useMemo, useState } from 'react';

import { Loader } from '@/shared/components';

type LoaderProviderContextType = {
  showLoader: VoidFunction;
  hideLoader: VoidFunction;
};

export const LoaderProviderContext = createContext({} as LoaderProviderContextType);

export const LoaderProvider = ({ children }: PropsWithChildren) => {
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

  const showLoader = useCallback(() => setIsLoaderVisible(true), []);

  const hideLoader = useCallback(() => setIsLoaderVisible(false), []);

  const context = useMemo(
    () => ({
      hideLoader,
      showLoader,
    }),
    [hideLoader, showLoader],
  );

  return (
    <LoaderProviderContext.Provider value={context}>
      {children}
      {isLoaderVisible && <Loader isSpinning />}
    </LoaderProviderContext.Provider>
  );
};
